import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { formValueSelector } from 'redux-form';
import ModalWrapper from 'components/Modals/ModalWrapper';
import ModalInstructions from 'components/ModalInstructions';
import MustHaveReadText from 'components/MustHaveReadText';

const PenaltiesOfPerjuryModal = ({ formType, onConfirm, onCancel, subjectToBackupWithholding }) => {
  const [allRead, setAllRead] = useState(false);
  const modalInstruction = ModalInstructions(formType, subjectToBackupWithholding);

  return (
    <ModalWrapper
      title={ <h1>Certification</h1> }
      disableConfirm={ !allRead }
      showCancel={ false }
      btnConfirmTitle="I Agree"
      content={ modalInstruction != null
      && <MustHaveReadText
        content={ modalInstruction.CertificationContent }
        IsTextRead={ value => setAllRead(value) }
      /> }
      footer={ !allRead ? 'You must read all of the text above before you can proceed.' : 'By clicking `I Agree` you declare that you have read and agree to the text above.' }
      onConfirm={ () => { onConfirm(); } }
      onCancel={ () => { onCancel(); } }
      id="certification-modal"
    />
  );
};

PenaltiesOfPerjuryModal.propTypes = {
  formType: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  subjectToBackupWithholding: PropTypes.bool,
};

PenaltiesOfPerjuryModal.defaultProps = {
  subjectToBackupWithholding: false,
};

const selector = formValueSelector('w9-form');

export default connect(
  (state) => {
    const subjectToBackupWithholding = selector(state, 'certification.subjectToBackupWithholding');
    return {
      subjectToBackupWithholding
    };
  }
)(PenaltiesOfPerjuryModal);
